<div class="ui-g-12">
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
    <label>
      {{ 'basic-profile.jurisdiction.choose-app-data' | translate }}
    </label>
    <p-dropdown
      [options]="applicationOptions"
      id="existing-applications"
      [(ngModel)]="selectedApplication"
      optionLabel="externalId"
      placeholder="-Select-"></p-dropdown>
  </div>

  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
    <button
      (click)="askCopyAppData()"
      [disabled]="!selectedApplication"
      class="submit-button"
      label="{{ 'basic-profile.jurisdiction.copy-app-data' | translate | uppercase }}"
      pButton></button>
  </div>
</div>
